import { render } from "./TimeCounter.vue?vue&type=template&id=2c512390&scoped=true"
import script from "./TimeCounter.vue?vue&type=script&lang=js"
export * from "./TimeCounter.vue?vue&type=script&lang=js"

import "./TimeCounter.vue?vue&type=style&index=0&id=2c512390&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c512390"]])

export default __exports__